/* GAI HOMEPAGE v5 JS — split-section patched */
(function(){'use strict';

// HERO — hero section has its own self-contained JS in split theme
// gai-hp.js hero init is a no-op here (slides live in .gai-hero-wrap not #gai)
var gS=Array.from(document.querySelectorAll('#gai .v5-slide'));
var gD=Array.from(document.querySelectorAll('#gai .v5-sdot'));
var gT=gS.length,gC=0,gTm;
function gGoTo(n){if(!gT)return;gS[gC].classList.remove('active');if(gD[gC])gD[gC].classList.remove('active');gC=((n%gT)+gT)%gT;gS[gC].classList.add('active');if(gD[gC])gD[gC].classList.add('active');var sn=document.getElementById('gSlideNum');if(sn)sn.textContent=gC+1;}
function gSM(d){gGoTo(gC+d);gRst();}
function gRst(){clearInterval(gTm);if(gT>1)gTm=setInterval(function(){gSM(1);},5500);}
window.gaiSlideMove=gSM;window.gaiGoTo=gGoTo;
if(gT>0){gS[0].classList.add('active');if(gD[0])gD[0].classList.add('active');gRst();}
var gH=document.querySelector('#gai .v5-hero');
if(gH){var tx=0;gH.addEventListener('touchstart',function(e){tx=e.touches[0].clientX;},{passive:true});gH.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-tx;if(Math.abs(dx)>44)gSM(dx<0?1:-1);},{passive:true});}

// TABS — used by gai-homepage monolith; split sections use gaiTabLocal()
window.gaiTab=function(btn,id){
  document.querySelectorAll('#gai .tab').forEach(function(t){t.classList.remove('active');});
  document.querySelectorAll('#gai .tab-panel').forEach(function(p){p.classList.remove('active');});
  btn.classList.add('active');
  var el=document.getElementById('gPanel-'+id);
  if(el)el.classList.add('active');
  setTimeout(function(){gai3D();gaiInitViewers();},80);
};

// DEITY ROW — used by gai-homepage monolith; split section uses gaiDeityScroll/gaiDeityTab
window.gaiGodScroll=function(dir){
  var row=document.getElementById('gGodRow');
  if(!row)return;
  var card=row.querySelector('.god-card');
  var w=card?(card.offsetWidth+10):100;
  gSmoothScroll(row,row.scrollLeft+dir*w,320);
};
window.gaiGodTab=function(btn,panelId){
  var wasActive=btn.classList.contains('g-active');
  document.querySelectorAll('#gGodRow .god-card').forEach(function(c){c.classList.remove('g-active');});
  // PATCHED: was '#gai .deity-panel' — now global so split sections work
  document.querySelectorAll('.deity-panel').forEach(function(p){p.classList.remove('g-open');p.style.display='none';});
  if(!wasActive){btn.classList.add('g-active');var panel=document.getElementById(panelId);if(panel){panel.classList.add('g-open');panel.style.display='block';panel.scrollIntoView({behavior:'smooth',block:'nearest'});setTimeout(function(){gai3D();gaiInitViewers();},80);}}
};

// SMOOTH SCROLL (rAF)
function gSmoothScroll(el,target,dur){
  var start=el.scrollLeft,diff=target-start,startT=null;
  function ease(t){return t<.5?2*t*t:-1+(4-2*t)*t;}
  function step(now){if(!startT)startT=now;var p=Math.min((now-startT)/dur,1);el.scrollLeft=start+diff*ease(p);if(p<1)requestAnimationFrame(step);}
  requestAnimationFrame(step);
}

// QUICK BUY
window.gaiBuyNow=function(btn){
  var id=btn.getAttribute('data-id');if(!id)return;
  var orig=btn.innerHTML;btn.disabled=true;btn.textContent='...';
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})})
  .then(function(r){if(!r.ok)throw 0;return r.json();})
  .then(function(){if(window.shiprocketCheckoutEvents&&typeof shiprocketCheckoutEvents.buyCart==='function')shiprocketCheckoutEvents.buyCart();else window.location.href='/checkout';})
  .catch(function(){btn.innerHTML=orig;btn.disabled=false;var h=btn.getAttribute('data-handle');window.location.href=h?'/products/'+h:'/cart';});
};

// 3D TILT — PATCHED: was '#gai .pc-img', now global '.pc-img'
function gai3D(){
  document.querySelectorAll('.pc-img').forEach(function(wrap){
    if(wrap._g3d)return;wrap._g3d=true;
    var img=wrap.querySelector('img');if(!img)return;
    wrap.addEventListener('mousemove',function(e){var r=wrap.getBoundingClientRect();var x=((e.clientX-r.left)/r.width-.5)*14;var y=((e.clientY-r.top)/r.height-.5)*-14;img.style.transition='transform .08s ease';img.style.transform='perspective(480px) rotateY('+x+'deg) rotateX('+y+'deg) scale(1.07)';});
    wrap.addEventListener('mouseleave',function(){img.style.transition='transform .45s ease';img.style.transform='';});
  });
}
gai3D();

// SALES METER
var HD=[.005,.010,.013,.015,.017,.022,.035,.065,.110,.175,.240,.295,.340,.375,.410,.445,.490,.545,.610,.690,.775,.840,.900,.950];
var MC={aN:248,aF:496,bN:52,bF:100,wN:13,wF:25,fm:[10,11,12,1],v:.04};
function isFest(){return MC.fm.indexOf(new Date().getMonth()+1)>-1;}
function getCF(){var h=new Date().getHours(),m=new Date().getMinutes()/60;return HD[h]+(h<23?HD[h+1]-HD[h]:1-HD[h])*m;}
function gRnd(n){return Math.round(n*(1+(Math.random()*2-1)*MC.v));}
function gFmt(n){return n>=1000?(n/1000).toFixed(1)+'k':String(n);}
function gSt(id,v){var e=document.getElementById(id);if(e)e.textContent=v;}
function gSw(id,v){var e=document.getElementById(id);if(e)e.style.width=v;}
function gUpM(){var f=isFest(),cf=getCF();var a=gRnd(Math.round((f?MC.aF:MC.aN)*cf));var b=gRnd(Math.round((f?MC.bF:MC.bN)*cf));var w=gRnd(Math.round((f?MC.wF:MC.wN)*cf));var tot=a+b+w;gSt('gMN',gFmt(tot));gSt('gAN',gFmt(a));gSt('gBN',gFmt(b));gSt('gWN',gFmt(w));var pct=Math.min(98,Math.round(cf*100));gSw('gMBar',pct+'%');gSw('gABar',Math.min(98,a/MC.aN*100)+'%');gSw('gBBar',Math.min(98,b/MC.bN*100)+'%');gSw('gWBar',Math.min(98,w/MC.wN*100)+'%');gSt('gMPct',pct+'% of day');gSt('gFN',Math.round(tot*.85)+' people');gSt('gFPlus','+'+Math.max(0,Math.round(tot*.85)-5));gSt('gMTime',new Date().toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'}));}
if(document.getElementById('gMN')){gUpM();setInterval(gUpM,45000);}

// COUNTDOWN
function gUpCD(){var w=document.getElementById('gCountdown');if(!w)return;var ds=w.getAttribute('data-date');if(!ds)return;var diff=new Date(ds)-new Date();if(diff<=0){w.innerHTML='<div style="font-size:13px;color:#c9a84c;letter-spacing:2px;text-transform:uppercase;">🎉 Sale is LIVE!</div>';return;}gSt('gCdD',String(Math.floor(diff/86400000)).padStart(2,'0'));gSt('gCdH',String(Math.floor((diff%86400000)/3600000)).padStart(2,'0'));gSt('gCdM',String(Math.floor((diff%3600000)/60000)).padStart(2,'0'));gSt('gCdS',String(Math.floor((diff%60000)/1000)).padStart(2,'0'));}
if(document.getElementById('gCountdown')){gUpCD();setInterval(gUpCD,1000);}

// FOMO POPUP
var gFN=['Priya','Rahul','Ananya','Vikram','Sonal','Deepa','Amit','Kavya','Ravi','Sunita','Arjun','Meera','Nikhil','Pooja','Suresh','Divya','Karthik','Rohit'];
var gSN=['Sharma','Verma','Iyer','Nair','Reddy','Patel','Gupta','Singh','Kumar','Rao','Joshi','Mehta','Pillai','Shah'];
var gCT=['Mumbai','Delhi','Bengaluru','Hyderabad','Chennai','Ahmedabad','Pune','Kolkata','Jaipur','Surat','Lucknow','Nagpur','Indore','Kochi','Mysuru'];
var gPR=[{p:'Mango Ganesha Car Idol',i:'🐘',r:'₹799'},{p:'Lord Ram Idol 5.7"',i:'🏹',r:'₹3,999'},{p:'Panchmukhi Hanuman',i:'🙏',r:'₹2,499'},{p:'Kamdhenu Cow & Calf',i:'🐄',r:'₹3,799'},{p:'Bal Gopal Krishna',i:'🦚',r:'₹1,799'},{p:'Tirupati Balaji',i:'🌟',r:'₹4,299'}];
var gTM=['just now','1 min ago','2 min ago','3 min ago','5 min ago'];
function gREl(a){return a[Math.floor(Math.random()*a.length)];}
function gShowP(){var el=document.getElementById('gSpop');if(!el)return;var p=gREl(gPR);gSt('gSpIco',p.i);gSt('gSpNm',gREl(gFN)+' '+gREl(gSN)+' from '+gREl(gCT));gSt('gSpDt','ordered '+p.p+' ('+p.r+')');gSt('gSpTm',gREl(gTM));el.classList.add('show');setTimeout(function(){el.classList.remove('show');},5000);}
setTimeout(gShowP,4000);setInterval(gShowP,18000);

// BLOG CAROUSEL
window.gaiBlogScroll=function(dir){
  var row=document.getElementById('gBlogRow');
  if(!row)return;
  var card=row.querySelector('.blog-card');
  var w=card?(card.offsetWidth+16):Math.round(row.clientWidth/3+16);
  gSmoothScroll(row,row.scrollLeft+dir*w,380);
};

// FESTIVAL BANNER
var FESTIVALS=[
  {n:'Ganesh Chaturthi',m:8,d:27,col:'/collections/ganesha-idols-for-car-dashboard'},
  {n:'Navratri',m:9,d:29,col:'/collections/best-selling-hindu-idols-gifts'},
  {n:'Dussehra',m:10,d:2,col:'/collections/best-selling-hindu-idols-gifts'},
  {n:'Dhanteras',m:10,d:20,col:'/collections/lakshmi-idols-gold-silver-plated'},
  {n:'Diwali',m:10,d:21,col:'/collections/laxmi-ganesh-idols-gold-silver-decorative-collection'},
  {n:'Bhai Dooj',m:10,d:23,col:'/collections/best-selling-hindu-idols-gifts'},
  {n:'Kartik Purnima',m:11,d:5,col:'/collections/best-selling-hindu-idols-gifts'},
  {n:'Margashirsha Puja',m:11,d:28,col:'/collections/best-selling-hindu-idols-gifts'},
  {n:'Makar Sankranti',m:1,d:14,col:'/collections/best-selling-hindu-idols-gifts'},
  {n:'Maha Shivratri',m:2,d:18,col:'/collections/lord-shiva-idol'},
  {n:'Ram Navami',m:4,d:6,col:'/collections/best-selling-hindu-idols-gifts'},
  {n:'Akshaya Tritiya',m:4,d:30,col:'/collections/lakshmi-idols-gold-silver-plated'},
  {n:'Guru Purnima',m:7,d:10,col:'/collections/best-selling-hindu-idols-gifts'},
];
function gGetFest(){
  var now=new Date(),y=now.getFullYear();
  for(var i=0;i<FESTIVALS.length;i++){var f=FESTIVALS[i];var fd=new Date(y,f.m-1,f.d);if(fd>now)return {n:f.n,d:fd,col:f.col};}
  var first=FESTIVALS[0];return {n:first.n,d:new Date(y+1,first.m-1,first.d),col:first.col};
}
function gInitFest(){
  var banner=document.getElementById('gFestBanner');if(!banner)return;
  var nf=gGetFest();
  var diff=Math.ceil((nf.d-new Date())/86400000);
  if(diff>55){banner.style.display='none';return;}
  var orderBy=new Date(nf.d.getTime()-3*86400000);
  var months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var obStr=months[orderBy.getMonth()]+' '+orderBy.getDate();
  var dn=document.getElementById('gFestDays');if(dn)dn.textContent=diff;
  var nn=document.getElementById('gFestName');if(nn)nn.textContent=nf.n;
  var od=document.getElementById('gFestOrderBy');if(od)od.textContent=obStr;
  var cl=document.getElementById('gFestLink');if(cl)cl.href=nf.col;
  banner.style.display='';
}
gInitFest();

// VIEWERS COUNTER — PATCHED: was '#gai .pc-viewers', now global '.pc-viewers'
var V_CURVE=[2,3,4,5,6,7,9,14,20,28,36,42,48,52,56,58,60,55,48,38,30,22,15,8];
function gViewers(rank){
  var h=new Date().getHours();
  var base=V_CURVE[h];
  var decay=Math.max(0.25,1-(rank-1)*0.14);
  return Math.max(2,Math.round(base*decay*(0.75+Math.random()*0.5)));
}
function gaiInitViewers(){
  document.querySelectorAll('.pc-viewers').forEach(function(el){
    if(el._vi)return;el._vi=true;
    var rank=parseInt(el.getAttribute('data-rank')||'1',10);
    function upd(){var v=gViewers(rank);el.innerHTML='<span class="pv-hot">'+v+' 👀</span> viewing this now';}
    upd();
    setInterval(upd,50000+Math.random()*30000);
  });
}
setTimeout(gaiInitViewers,1200);

// PINCODE CHECKER
var PIN_METRO={'40':2,'11':3,'56':3,'41':3,'50':3,'60':3,'70':4,'38':3,'30':4,'20':4};
var PIN_ZONE={'1':3,'2':4,'3':4,'4':2,'5':4,'6':4,'7':4,'8':5,'9':5};
function gPinDate(days){
  var months=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var weekdays=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var d=new Date();d.setDate(d.getDate()+days);
  return weekdays[d.getDay()]+', '+months[d.getMonth()]+' '+d.getDate();
}
window.gaiCheckPin=function(e){
  if(e&&e.preventDefault)e.preventDefault();
  var inp=document.getElementById('gPinIn'),res=document.getElementById('gPinRes');
  if(!inp||!res)return;
  var pin=(inp.value||'').trim();
  if(!/^\d{6}$/.test(pin)){res.className='pin-result show';res.innerHTML='<div class="pin-err">Please enter a valid 6-digit pincode.</div>';return;}
  var pfx=pin.substring(0,2),zone=pin.charAt(0);
  var days=PIN_METRO[pfx]||PIN_ZONE[zone]||5;
  var dateStr=gPinDate(days);
  res.className='pin-result show';
  res.innerHTML='<div class="pin-ok"><span class="pin-ok-ico">✅</span><div class="pin-ok-txt"><strong>Delivery by '+dateStr+' &middot; Free shipping</strong><span>Shipped from Mumbai via Shiprocket</span></div></div>';
};
var pinForm=document.getElementById('gPinForm');if(pinForm)pinForm.addEventListener('submit',window.gaiCheckPin);
var pinIn=document.getElementById('gPinIn');if(pinIn)pinIn.addEventListener('keydown',function(e){if(e.key==='Enter')window.gaiCheckPin(e);});

// EXIT INTENT POPUP
var gExShown=false;
function gShowExit(){
  if(gExShown||sessionStorage.getItem('gex_save10'))return;
  gExShown=true;sessionStorage.setItem('gex_save10','1');
  var el=document.getElementById('gai-exit');if(el)el.classList.add('gex-show');
}
window.gaiExitClose=function(){
  var el=document.getElementById('gai-exit');if(el)el.classList.remove('gex-show');
};
window.gaiCopyCode=function(){
  var code='SAVE10';
  if(navigator.clipboard&&navigator.clipboard.writeText){
    navigator.clipboard.writeText(code).then(function(){
      var c=document.getElementById('gExCopied');
      if(c){c.textContent='Copied! Paste at checkout.';setTimeout(function(){c.textContent='';},3000);}
    });
  }
};
document.addEventListener('mouseleave',function(e){if(e.clientY<10)setTimeout(gShowExit,150);});
setTimeout(function(){if(window.scrollY>window.innerHeight*0.4)gShowExit();},35000);

// QUICK VIEW
var gQVid=null,gQVimgEl=null;
function gQVfmt(src){if(!src)return'';return src.replace(/_(\d+)x(\d+)\./,'.').replace(/\.(jpg|jpeg|png|webp)/i,'_600x.$1');}
function gQVsetVariant(id,handle,price,compare,imgSrc){
  gQVid=id;var vid=document.getElementById('gQVvariantId');if(vid)vid.value=String(id);
  var bn=document.getElementById('gQVbuy');if(bn){bn.setAttribute('data-id',String(id));bn.setAttribute('data-handle',handle||'');}
  function fmt(c){return '\u20b9'+Math.round(c/100).toLocaleString('en-IN');}
  gSt('gQVprice',fmt(price));
  if(compare&&compare>price){gSt('gQVorig',fmt(compare));gSt('gQVsave','-'+Math.round((compare-price)/compare*100)+'%');}
  else{gSt('gQVorig','');gSt('gQVsave','');}
  if(imgSrc&&gQVimgEl){gQVimgEl.classList.remove('gzoom');gQVimgEl.src=imgSrc;}
}
window.gaiQV=function(btn){
  var handle=btn.getAttribute('data-handle');if(!handle)return;
  var bg=document.getElementById('gQVbg'),modal=document.getElementById('gQVmodal');
  if(!bg||!modal)return;
  gSt('gQVtitle','Loading\u2026');gSt('gQVtype','');gSt('gQVprice','');gSt('gQVorig','');gSt('gQVsave','');
  document.getElementById('gQVvars').innerHTML='';
  gQVimgEl=document.querySelector('#gQVimgwrap img');
  if(gQVimgEl){gQVimgEl.src='';gQVimgEl.classList.remove('gzoom');}
  bg.classList.add('show');modal.classList.add('show');document.body.style.overflow='hidden';
  fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){
    if(gQVimgEl&&p.images&&p.images.length>0){gQVimgEl.src=gQVfmt(p.images[0]);gQVimgEl.alt=p.title;}
    gSt('gQVtype',p.type||'');gSt('gQVtitle',p.title);
    var pu=document.getElementById('gQVproductUrl');if(pu)pu.value='/products/'+p.handle;
    var fl=document.getElementById('gQVfull');if(fl)fl.href='/products/'+p.handle;
    var v=p.variants[0];
    gQVsetVariant(v.id,p.handle,v.price,v.compare_at_price,v.featured_image?gQVfmt(v.featured_image.src):null);
    if(gQVimgEl&&p.images&&p.images.length>0&&!v.featured_image)gQVimgEl.src=gQVfmt(p.images[0]);
    if(p.variants.length>1){var vw=document.getElementById('gQVvars');p.variants.forEach(function(vr,i){var b2=document.createElement('button');b2.type='button';b2.className='gqv-vbtn'+(i===0?' sel':'');if(vr.featured_image&&vr.featured_image.src){var th=document.createElement('img');th.src=gQVfmt(vr.featured_image.src).replace('_600x.','_80x.');th.style.cssText='width:22px;height:22px;object-fit:cover;border-radius:2px;vertical-align:middle;margin-right:4px;pointer-events:none;';b2.appendChild(th);}b2.appendChild(document.createTextNode(vr.title));b2.onclick=function(){document.querySelectorAll('.gqv-vbtn').forEach(function(x){x.classList.remove('sel');});b2.classList.add('sel');gQVsetVariant(vr.id,p.handle,vr.price,vr.compare_at_price,vr.featured_image?gQVfmt(vr.featured_image.src):null);};vw.appendChild(b2);});}
  }).catch(function(){gSt('gQVtitle','Unable to load product.');});
};
window.gaiQVClose=function(){var bg=document.getElementById('gQVbg'),modal=document.getElementById('gQVmodal');if(bg)bg.classList.remove('show');if(modal)modal.classList.remove('show');document.body.style.overflow='';};
var gForm=document.getElementById('gQVform');if(gForm)gForm.addEventListener('submit',function(){gaiQVClose();});
window.gaiQVBuyNow=function(){var bb=document.getElementById('gQVbuy');if(!gQVid||!bb)return;var orig=bb.textContent;bb.disabled=true;bb.textContent='...';fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:gQVid,quantity:1}]})}).then(function(r){if(!r.ok)throw 0;return r.json();}).then(function(){gaiQVClose();setTimeout(function(){if(window.shiprocketCheckoutEvents&&typeof shiprocketCheckoutEvents.buyCart==='function')shiprocketCheckoutEvents.buyCart();else window.location.href='/checkout';},100);}).catch(function(){bb.textContent=orig;bb.disabled=false;});};
var gQVi=document.querySelector('#gQVimgwrap img');if(gQVi)gQVi.addEventListener('click',function(){gQVi.classList.toggle('gzoom');});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&window.gaiQVClose)gaiQVClose();});

})();
